import React, { useEffect, useState } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Spin,
  Card,
  InputNumber,
} from "antd";
import { SaveOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";
import {
  FormItemLabelWithTooltip,
  tenantParameterFormItemLayout,
} from "./TenantParameterFormHelpers";

const TenantInfoForm = ({ data, loading, onSuccess }) => {
  const [form] = Form.useForm();
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        tenantTitle: data.tenantTitle,
        tenantAddress: data.tenantAddress,
        tenantPhoneNumber: data.tenantPhoneNumber,
        tenantWebSite: data.tenantWebSite,
        tenantMersisNo: data.tenantMersisNo,
        tenantTaxOffice: data.tenantTaxOffice,
        tenantCapital: data.tenantCapital,
        tenantName: data.tenantName,
      });
    }
  }, [data, form]);

  const onFinish = (values) => {
    setSubmitLoading(true);
    RequestHandler.put("/Tenant/UpdateTenantInfo", {
      id: data.tenantId,
      title: values.tenantTitle,
      address: values.tenantAddress,
      phoneNumber: values.tenantPhoneNumber,
      webSite: values.tenantWebSite,
      mersisNo: values.tenantMersisNo,
      taxOffice: values.tenantTaxOffice,
      capital: values.tenantCapital,
    }).then((response) => {
      setSubmitLoading(false);
      if (response?.success) {
        if (onSuccess) onSuccess();
      }
    });
  };

  return (
    <Spin spinning={loading}>
      <Form
        {...tenantParameterFormItemLayout}
        validateMessages={defaultValidateMessages}
        form={form}
        name="TenantReceiptInfoUpdate"
        onFinish={onFinish}
        onFinishFailed={() => setSubmitLoading(false)}
      >
        <Row justify="center">
          <Col xs={24} sm={16}>
            <Card className="gx-card" style={{ margin: "10px 0" }}>
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Unvan"
                    tooltip={
                      <>
                        <p>
                          B2B dekontlarında görünecek kısa firma unvanıdır.
                        </p>
                        <p>
                          Boş bırakılırsa sistemdeki firma adı dekontta
                          kullanılır.
                        </p>
                      </>
                    }
                  />
                }
                name="tenantTitle"
              >
                <Input maxLength={250} placeholder="Unvan" />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Adres"
                    tooltip="Firma adresi B2B dekontlarında firma bilgileri bölümünde gösterilir."
                  />
                }
                name="tenantAddress"
              >
                <Input.TextArea
                  maxLength={500}
                  rows={3}
                  placeholder="Firma adresi"
                />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Telefon Numarası"
                    // tooltip="Telefon numarası B2B dekontlarında firma bilgileri bölümünde gösterilir."
                  />
                }
                name="tenantPhoneNumber"
                rules={[
                  {
                    pattern: /^$|^\d{10}$/,
                    message: "Telefon numarası 10 haneli olmalıdır.",
                  },
                ]}
              >
                <Input maxLength={10} placeholder="5XXXXXXXXX" />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Web Adresi"
                    tooltip="Web adresi girilirse B2B dekontlarında logo altında görüntülenir. Boş bırakılırsa dekontta gösterilmez."
                  />
                }
                name="tenantWebSite"
              >
                <Input maxLength={300} placeholder="https://www.ornek.com" />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="MERSİS No"
                    tooltip="MERSİS numarası B2B dekontta firma bilgileri bölümünde telefon numarasının yanında gösterilir. Boş bırakılırsa dekontta gösterilmez."
                  />
                }
                name="tenantMersisNo"
              >
                <Input maxLength={16} placeholder="MERSİS numarası" />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Vergi Dairesi"
                    // tooltip="Vergi dairesi dekontta vergi numarasının yanında gösterilir."
                  />
                }
                name="tenantTaxOffice"
              >
                <Input maxLength={100} placeholder="Vergi dairesi" />
              </Form.Item>

              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Sermaye"
                    tooltip="Sermaye tutarı B2B dekontta firma bilgileri bölümünde adres satırında gösterilir. Boş bırakılırsa dekontta gösterilmez."
                  />
                }
                name="tenantCapital"
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  precision={2}
                  decimalSeparator=","
                  placeholder="Sermaye tutarı (TL)"
                />
              </Form.Item>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Col style={{ textAlign: "right" }}>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                htmlType="submit"
                onClick={() => setSubmitLoading(true)}
                loading={submitLoading}
              >
                Kaydet
              </Button>
            </Col>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default TenantInfoForm;
